import { useState } from "react";
import SideMenu from "../../components/organisms/SideMenu";
import CommonData from "./content/CommonData";
import OurSupport from "./content/OurSupport";
import Partners from "./content/Prtners";
import FAQ from "./content/FAQ";

interface MenuItem {
  id: number;
  name: string;
}

export default function ContentEdit() {
  const MenuItems: MenuItem[] = [
    { id: 11, name: "Common Data" },
    { id: 12, name: "Our Support" },
    { id: 13, name: "Partners" },
    { id: 14, name: "FAQ" },
  ];

  const [activeMenuItem, setActiveMenuItem] = useState<string>("Common Data");

  return (
    <div className="flex">
      <SideMenu />
      <div className="p-6 bg-background w-full space-y-6">
        <div className="flex items-center space-x-10">
          <div className="space-y-1">
            <h1 className="font-primary text-[32px]">Content</h1>
            <p>Manage your content shown on the website</p>
          </div>
        </div>

        <div className="flex space-x-4">
          {MenuItems.map((item) => (
            <p
              key={item.id}
              onClick={() => setActiveMenuItem(item.name)}
              className={`border border-primary p-2 px-4 rounded hover:bg-primary hover:text-white duration-300 hover:cursor-pointer ${
                activeMenuItem === item.name
                  ? "bg-primary text-white"
                  : "bg-primary/[.10]"
              }`}
            >
              {item.name}
            </p>
          ))}
        </div>

        {activeMenuItem === "Common Data" && (
          <div>
            <CommonData />
          </div>
        )}
        {activeMenuItem === "Our Support" && (
          <div>
            <OurSupport />
          </div>
        )}
        {activeMenuItem === "Partners" && <Partners />}
        {activeMenuItem === "FAQ" && <FAQ />}
      </div>
    </div>
  );
}
